import type { MockHeaderType } from 'components/Header/types';

import Image from 'components/Image';
import useStyles from './styles';

export default function MockHeader({ onClick }: MockHeaderType) {
  const styles = useStyles();

  return (
    <header className={styles.root} data-testid="mock-header-component">
      <div className={styles.logoWrapper}>
        {/* TODO fix accessibility */}
        <div onClick={onClick} role="presentation" tabIndex={0} className={styles.imageContainer}>
          <Image
            src="https://yearly-cdn.picsart.com/cdn140/28410169050081638995.svg"
            className={styles.logo}
          />
        </div>
      </div>
    </header>
  );
}
